export default __webpack_public_path__ + "static/media/Boots of the Painlegion.5501e252.jpg";